export let SelectedMailRequest = {
    "id": 11231537,
    "selectInqAssignedGroupId": [
      2533
    ],
    "isAllConvContent": false,
    "hasNominatedOwnership": false
  }